import React, { useState, useRef, useEffect } from "react";
import { Copy, Check, Mail, X } from "lucide-react";
import WhiteLogo from "../assets/KavoaWhiteLogo.png";

const FooterSection: React.FC = () => {
  const [showContact, setShowContact] = useState(false);
  const [copied, setCopied] = useState(false);
  const popupRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!showContact) return;
    const handleClick = (e: MouseEvent) => {
      if (popupRef.current && !popupRef.current.contains(e.target as Node)) {
        setShowContact(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [showContact]);

  const handleCopy = async () => {
    await navigator.clipboard.writeText("support@kavoa.io");
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <footer className="bg-slate-900 py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pb-8 border-b border-slate-800">
          <div className="flex items-center">
            <img src={WhiteLogo} alt="Kavoa" className="h-24 object-contain" />
          </div>
          <div className="flex items-center gap-8 text-base md:text-sm text-slate-400">
            <a href="/pricing" className="hover:text-white transition-colors">
              Pricing
            </a>
            <a href="/privacy" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-white transition-colors">
              Terms of Service
            </a>
            <div className="relative inline-flex" ref={popupRef}>
              <button
                onClick={() => { setShowContact(!showContact); setCopied(false); }}
                className="hover:text-white transition-colors font-inherit"
                style={{ font: "inherit", color: "inherit" }}
              >
                Contact
              </button>
              {showContact && (
                <div className="absolute bottom-full right-0 mb-3 w-72 animate-in fade-in slide-in-from-bottom-2 duration-200">
                  <div className="bg-white rounded-xl shadow-2xl border border-slate-200 overflow-hidden">
                    <div className="flex items-center justify-between px-4 pt-4 pb-2">
                      <div className="flex items-center gap-2">
                        <div className="h-8 w-8 rounded-lg flex items-center justify-center" style={{ backgroundColor: "#0F5132" }}>
                          <Mail className="h-4 w-4 text-white" />
                        </div>
                        <div>
                          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider">Contact Us</p>
                        </div>
                      </div>
                      <button
                        onClick={() => setShowContact(false)}
                        className="p-1 rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors"
                      >
                        <X className="h-4 w-4" />
                      </button>
                    </div>
                    <div className="px-4 pb-4 pt-2">
                      <div className="flex items-center gap-2 bg-slate-50 rounded-lg p-3">
                        <span className="flex-1 text-sm font-medium text-slate-700 select-all">
                          support@kavoa.io
                        </span>
                        <button
                          onClick={handleCopy}
                          className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-semibold transition-all ${
                            copied
                              ? "bg-emerald-50 text-emerald-600"
                              : "bg-white text-slate-600 hover:bg-slate-100 border border-slate-200"
                          }`}
                        >
                          {copied ? (
                            <>
                              <Check className="h-3.5 w-3.5" />
                              Copied!
                            </>
                          ) : (
                            <>
                              <Copy className="h-3.5 w-3.5" />
                              Copy
                            </>
                          )}
                        </button>
                      </div>

                    </div>
                  </div>
                  {/* Arrow */}
                  <div className="absolute right-4 -bottom-2 w-4 h-4 bg-white border-r border-b border-slate-200 transform rotate-45" />
                </div>
              )}
            </div>
          </div>
        </div>
        <p className="text-center text-sm text-slate-500 mt-8">
          &copy; {new Date().getFullYear()} Kavoa. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default FooterSection;
